<div class="platformsWrap  bg-[#121A22]">
    <div class="maxContainer items-center xl:flex-row flex-col g-3 gap-y-5  flex bg-[#121A22] py-4">
        <h2 class="lg:ps-7 lg:mb-0 mb-3 text-gradient">Available integrations</h2>
        <!-- <div class="imagesWrap hidden md:flex">
            <img src="assets/images/payment-gateway/IOS_logo.png" alt="">
            <img src="assets/images/payment-gateway/magento.png" alt="">
            <img src="assets/images/payment-gateway/woocommerce.png" alt="">
            <img src="assets/images/payment-gateway/easyintegration.png" alt="">
            <img src="assets/images/payment-gateway/android.png" alt="">
        </div> -->

        <div class="slideWrap">
            <ngx-slick-carousel class="carousel" 
                #slickModal="slick-carousel" 
                [config]="slideConfig" 
                >
                <div ngxSlickItem class="flex items-center justify-center" *ngFor="let d of data" >
                     <div class="slide flex justify-start md:justify-center items-center "  >
                        <img height="40px" class="max-w-[50%] !h-[40px] md:max-w-full" src="assets/images/payment-gateway/{{d.name}}" alt="">
                     </div>
               </div>
               
    </ngx-slick-carousel>
        </div>
    </div>
</div>